import { render, staticRenderFns } from "./FieldRule.vue?vue&type=template&id=5886e8e6"
import script from "./FieldRule.vue?vue&type=script&lang=js"
export * from "./FieldRule.vue?vue&type=script&lang=js"
import style0 from "./FieldRule.vue?vue&type=style&index=0&id=5886e8e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports